module.exports = "SERVICE_ROOM_INFO,,,,\r\nname,use_type,room_type,capacity,group_name\r\n"